import styled from '@emotion/styled';
import { Grid3x3 } from 'lucide-react';
import React from 'react';
import InspectorSection from '../shared/inspector-section';
import type { ObjectInspectorProps } from '../types';

const GridFitSection: React.FC<ObjectInspectorProps> = ({ objects, editor }) => {
  const grid = editor.grid;
  if (!grid || objects.length === 0) return null;

  return (
    <InspectorSection title="Сетка">
      <Button type="button" title="Подогнать по сетке (Alt + G)" onClick={() => grid.fitToGrid()}>
        <Grid3x3 size={14} />
        <span>Подогнать по сетке</span>
      </Button>
    </InspectorSection>
  );
};

export default GridFitSection;

const Button = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 6px 8px;
  font-size: 12px;
  color: #111827;
  background: #ffffff;
  border: 1px solid #d1d5db;
  border-radius: 4px;
  cursor: pointer;

  &:hover:not(:disabled) {
    background: #f3f4f6;
  }

  &:disabled {
    color: #9ca3af;
    cursor: not-allowed;
    background: #f9fafb;
  }
`;
